import { render } from "./processWizard.vue?vue&type=template&id=83e3aa24&scoped=true"
import script from "./processWizard.vue?vue&type=script&lang=js"
export * from "./processWizard.vue?vue&type=script&lang=js"

import "./processWizard.vue?vue&type=style&index=0&id=83e3aa24&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83e3aa24"]])

export default __exports__